import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { useDispatch, useSelector } from 'react-redux';
import { makeSelectLiteTradeFilteredCollectionByKey } from '../liteTradeSelectors';
import { getUserSelectedAccountType } from '../../../app/appSelectors';
import { useCallback, useMemo } from 'react';
import { logAppsflyerAction } from '../../../app/appActions';
import { LOG_AF_EVENT_NAMES } from '../../../app/appConstants';
import { locationSlice } from '../../Location/locationReducer';
import { LOCATION_NAMES } from '../../Location/locationConstants';
import { COLLECTION_KEYS } from '../../../mobileAppCore/components/MobileMarket/mobileMarketConstants';

export const useLiteTradeCollection = (collectionKey: string) => {
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const data = useSelector(makeSelectLiteTradeFilteredCollectionByKey(collectionKey));
    const selectedAccountType = useSelector(getUserSelectedAccountType);

    const title = useMemo(() => {
        const langCollectionTitle = getLangPath(`lite_version.collections.${collectionKey}.title`, {}, { emptyDefault: true });
        const currentTitle = collectionKey !== COLLECTION_KEYS.ALL
            ? data?.title
            : langCollectionTitle;
        return currentTitle || '';
    }, [getLangPath, collectionKey, data]);

    const description = useMemo(() => {
        const langCollectionDescription = getLangPath(`lite_version.collections.${collectionKey}.description`, {}, { emptyDefault: true });
        const currentDescription = collectionKey !== COLLECTION_KEYS.ALL
            ? data?.description
            : langCollectionDescription;
        return currentDescription || '';
    }, [getLangPath, collectionKey, data]);

    const menuTitle = useMemo(() => {
        const langCollectionMenu = getLangPath(`lite_version.collections.${collectionKey}.menu`, {}, { emptyDefault: true });
        return langCollectionMenu || title;
    }, [getLangPath, collectionKey, title]);

    const openCollectionSlide = useCallback((source, searchParams = {}) => {
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.COLLECTION, searchParams: {
                ...searchParams,
                collection_key: collectionKey,
            },
        }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MARKET_COLLECTION_CLICK,
            payload: {
                account_type: selectedAccountType,
                collection_key: collectionKey,
                widget_key: source,
            },
        }));
    }, [collectionKey, dispatch, selectedAccountType]);

    return { data, title, menuTitle, description, openCollectionSlide };
};
